import de from '@translations/de/products.json';
import en from '@translations/en/products.json';
import pl from '@translations/pl/products.json';
import sl from '@translations/sl/products.json';
import uk from '@translations/uk/products.json';
import bg from '@translations/bg/products.json';
import cz from '@translations/cz/products.json';
import fr from '@translations/fr/products.json';
import gr from '@translations/gr/products.json';
import it from '@translations/it/products.json';
import pr from '@translations/pr/products.json';
import ru from '@translations/ru/products.json';
import sk from '@translations/sk/products.json';
import sp from '@translations/sp/products.json';
import tr from '@translations/tr/products.json';
import hu from '@translations/hu/products.json';
import { ITranslations } from '@/types/common';
import { ProductsTransFields } from './types';

export const productsTranslations: ITranslations<ProductsTransFields> = {
  name: 'products',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
